import React, { FC, memo, useEffect, useState } from 'react';
import {
  Box,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Select,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { factories } from '../../../../utils/variables/factotries';
import { useRecoilState } from 'recoil';
import { userState } from '../../../../states/userState';
import { User, InitialParameters } from '../../../../types/index';
import { setUserToLocalStorage } from '../../../../utils/functions/localStorageManager';
import { foreColorChecked } from '../../../../utils/functions/colors';
const SelectBoxForFactory: FC = memo(() => {
  const theme = useTheme();
  const isIphone = useMediaQuery(theme.breakpoints.down('sm'));

  const [user, setUser] = useRecoilState<User>(userState);
  const [checkedArray, setCheckedArray] = useState<Array<boolean>>([]);
  //   const [valueArray, setValueArray] = useState<Array<number>>([]);
  //checkboxの初期値設定
  useEffect(() => {
    // 全工場が選択されている場合
    if (user.initialParameters.factoryNo.includes(0)) {
      setCheckedArray(new Array(factories.length - 1).fill(true));
    } else {
      // 特定の工場が選択されている場合
      const newCheckedArray = factories
        .slice(1)
        .map((factory) =>
          user.initialParameters.factoryNo.includes(factory.id)
        );
      setCheckedArray(newCheckedArray);
    }
  }, [user.initialParameters.factoryNo]);
  const [displayString, setDisplayString] = useState<String[]>(['全工場']);
  useEffect(() => {
    // user.initialParameters.factoryNoが空、または全工場(0)を含む場合は、"全工場"と表示
    if (
      user.initialParameters.factoryNo.length === 0 ||
      user.initialParameters.factoryNo.includes(0)
    ) {
      setDisplayString(['全工場']);
    } else {
      // user.initialParameters.factoryNoに含まれる各idに対応するfactoriesのshortNameを結合
      const names = user.initialParameters.factoryNo
        .map((id) => factories.find((factory) => factory.id === id)?.shortName)
        .filter((name) => name !== undefined); // undefinedを除外
      // .join(" "); // 半角スペースで結合
      setDisplayString(names as String[]);
    }
  }, [user.initialParameters.factoryNo]);
  const children = (
    <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
      {factories.slice(1).map((factory, index) => (
        <FormControlLabel
          key={factory.id}
          sx={{
            height: '38px',
            marginLeft: '-14px',
            fontSize: '0.8rem',
            color: theme.palette.foreColor.main,
            backgroundColor: theme.palette.backColor.main,
            // 選択された状態のスタイル
            '&.Mui-selected': {
              backgroundColor: theme.palette.backColor.main, // 選択時の背景色を変更
              color: theme.palette.foreColor.light, // 選択時の文字色を変更
            },

            // ホバー状態のスタイルも定義できます
            '&:hover': {
              backgroundColor: theme.palette.backColor.main, // ホバー時の背景色を変更
              color: theme.palette.foreColor.light, // ホバー時の文字色を変更
            },
            // 選択されていてさらにホバーされた状態のスタイル
            '&.Mui-selected:hover': {
              backgroundColor: theme.palette.backColor.main, // 選択 + ホバー時の背景色
              color: theme.palette.foreColor.light, // 選択 + ホバー時の文字色
            },
          }}
          //   label={factory.name}
          //   sx={{ color: "#0adcc0" }}
          label={
            <MenuItem
              sx={{
                ...foreColorChecked(checkedArray[index]),
                fontSize: '0.8rem',
                '&:hover': {
                  backgroundColor: theme.palette.backColor.main, // ホバー時の背景色を変更
                  color: theme.palette.foreColor.light, // ホバー時の文字色を変更
                },
                p: 0,
                m: 0,
              }}
            >
              {factory.name}
            </MenuItem>
          }
          control={
            <Checkbox
              value={factory.id}
              checked={checkedArray[index]}
              onChange={(e) => handleChangeChild(e, index)}
              sx={{
                '& .MuiSvgIcon-root': theme.palette.foreColor.main,
                '&.Mui-checked': theme.palette.foreColor.main,
                height: '38px',
              }}
            />
          }
        />
      ))}
    </Box>
  );

  //Allがチェックされているか、一部がチェックされているか、全くチェックされていないかを判定
  const allChecked = checkedArray.every(Boolean);
  const indeterminate = checkedArray.some(Boolean) && !allChecked;
  //チェックボックス配列状態監視
  useEffect(() => {}, [checkedArray]);
  //工場番号デバッグ用
  // useEffect(() => {
  //   console.log(
  //     'user.initialParameters.factoryNo:',
  //     user.initialParameters.factoryNo
  //   );
  // }, [user.initialParameters.factoryNo]);
  //全工場選択
  const handleChangeAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    // 全てがチェックされているかどうかを確認
    const allChecked = checkedArray.every(Boolean);
    // 全てがチェックされていれば全解除、そうでなければ全選択
    const newCheckedArray = checkedArray.map(() => !allChecked);
    setCheckedArray(newCheckedArray);
    updateUserState(newCheckedArray);
    // setValueArray([]);
  };
  //個別工場選択
  const handleChangeChild = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const newCheckedArray = [...checkedArray];
    newCheckedArray[index] = event.target.checked;
    setCheckedArray(newCheckedArray);
    updateUserState(newCheckedArray);
    // setValueArray([]);
  };
  const updateUserState = (newCheckArray: Array<boolean>) => {
    // 全ての子チェックボックスが選択されている場合
    if (newCheckArray.every(Boolean)) {
      updateUserfactory([0]);
      //   setValueArray([0]); // 全工場を示す
    } else {
      const selectedValues = factories
        .slice(1)
        .reduce((acc, factory, index) => {
          if (newCheckArray[index]) acc.push(factory.id);
          return acc;
        }, [] as number[]);

      // チェック状態がすべてない状態を回避
      if (selectedValues.length === 0) {
        selectedValues.push(factories[1].id); // 最初の子工場をデフォルトで選択
        // const newCheckedArray = [...newCheckArray];
        // newCheckedArray[0] = true;
        // setCheckedArray(newCheckedArray);
      }
      updateUserfactory(selectedValues);
      //   setValueArray(selectedValues);
    }
  };

  // userStateの更新関数
  const updateUserfactory = (valueArray: Array<number>) => {
    setUser((prevState: User) => {
      const updatedUser = {
        ...prevState,
        initialParameters: {
          ...prevState.initialParameters,
          factoryNo: valueArray,
        },
      };
      setUserToLocalStorage(updatedUser);
      return updatedUser;
    });

    // setUser((prevState: User) => {
    //   // 現在のfactory配列と新しいvalueArrayが等しいかどうかを確認
    //   const isSameValueArray =
    //     JSON.stringify(prevState.filters.factory) ===
    //     JSON.stringify(valueArray);
    //   // 値が異なる場合のみ更新
    //   if (!isSameValueArray) {
    //     // ローカルストレージの更新も同様に条件内で行う
    //     const newUserState = {
    //       ...prevState,
    //       filters: {
    //         ...prevState.filters,
    //         factory: valueArray,
    //       },
    //     };
    //     setUserToLocalStorage(newUserState);
    //     return newUserState;
    //   }
    //   // 値が同じ場合は状態を変更せず現在の状態を返す
    //   return prevState;
    // });
  };

  return (
    <div>
      {checkedArray.length > 0 && (
        <>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={displayString}
            renderValue={(displayString) => displayString.join(',')}
            sx={{
              px: 0,
              py: 0,
              mx: 0,
              my: 0,
              boxShadow: '0px 0px 3px 1px #898b92',
              color: theme.palette.foreColor.main,
              height: '38px',
              width: isIphone ? '90px' : '160px',
              fontSize: '0.8rem',
              '& .MuiSvgIcon-root': {
                color: theme.palette.foreColor.main,
              },
              '&icon': {
                color: 'blue',
              },
              borderRadius: '5px',
              backgroundColor: theme.palette.backColor.main,

              '& .MuiSelect-select': {
                color: theme.palette.foreColor.main,
                // backgroundColor: theme.palette.backColor.main, // 選択エリアの背景色を設定
                // maxheight: "0px",
              },
            }}
            MenuProps={{
              PaperProps: {
                style: {
                  backgroundColor: theme.palette.backColor.main,

                  // 他のスタイルもここで指定できます。
                },
              },
            }}
          >
            <FormControlLabel
              // label="全工場"
              label={
                // style={{ color: allChecked ? "#0adcc0" : "#7D7C7C" }}
                <MenuItem
                  sx={{
                    ...foreColorChecked(allChecked),
                    fontSize: '0.8rem',
                    '&:hover': {
                      backgroundColor: theme.palette.backColor.main, // ホバー時の背景色を変更

                      color: theme.palette.foreColor.light, // ホバー時の文字色を変更
                    },
                    p: 0,
                    m: 0,
                  }}
                >
                  全工場
                </MenuItem>
              }
              sx={{
                height: '38px',
                mx: '5px',
                px: 0,
                py: 0,
                fontSize: '0.6rem',
                color: theme.palette.foreColor.main,
                backgroundColor: theme.palette.backColor.main,
                // 選択された状態のスタイル
                '&.Mui-selected': {
                  backgroundColor: theme.palette.backColor.main, // 選択時の背景色を変更
                  color: theme.palette.foreColor.light, // 選択時の文字色を変更
                  // color: "blue",
                },

                // ホバー状態のスタイルも定義できます
                '&:hover': {
                  backgroundColor: theme.palette.backColor.main, // ホバー時の背景色を変更
                  color: theme.palette.foreColor.light, // ホバー時の文字色を変更
                  // color: "blue",
                },
                // 選択されていてさらにホバーされた状態のスタイル
                '&.Mui-selected:hover': {
                  backgroundColor: theme.palette.backColor.main, // 選択 + ホバー時の背景色
                  color: theme.palette.foreColor.light, // 選択 + ホバー時の文字色
                },
              }}
              control={
                <Checkbox
                  checked={allChecked}
                  indeterminate={indeterminate}
                  onChange={handleChangeAll}
                  value={factories[0].id}
                  sx={{
                    '& .MuiSvgIcon-root': theme.palette.foreColor.main,
                    '&.Mui-checked': theme.palette.foreColor.main,
                    px: 0,
                    py: 0,
                    height: '38px',
                  }}
                />
              }
            />
            {children}
          </Select>
        </>
      )}
    </div>
  );
});

export default SelectBoxForFactory;
